export default __webpack_public_path__ + "static/media/make-move.156e9555.mp3";